import React, {useMemo, useRef} from 'react';
import {useReactTable, getCoreRowModel, getFilteredRowModel, getPaginationRowModel, flexRender} from "@tanstack/react-table";
import {formatLocation} from "../../utils/utils";

export function Table(props) {

    const _h3Ref = useRef(null);

    const getRowId = useMemo(() => {
        return (enterprise, relativeIndex) => `${enterprise.numeroStructure}-${relativeIndex}`
    }, [])
    const data = useMemo(
        () => props.data, [props.data]
    )
    const columns = useMemo(
        () => props.columns,
        [props.columns]
    )

    const table = useReactTable({
        data,
        columns,
        // Pipeline
        getCoreRowModel: getCoreRowModel(),
        getFilteredRowModel: getFilteredRowModel(),
        getPaginationRowModel: getPaginationRowModel(),
        //
        //debugTable: true,
    })

    return (
        <div className={"paginated-table"}>
            <h3 id="production-maif-table" tabIndex={-1} ref={_h3Ref}>Les entreprises soutenues {formatLocation(props.location, false)} <span className="sr-only">Page {table.getState().pagination.pageIndex + 1} sur {table.getPageCount()}</span></h3>
            <div className="table-container">
                <div className="table-content">

                    <div id="tableau-service" className="tableau-service">
                        <table className="tableau" aria-labelledby="production-maif-table">
                            <thead>
                            {table.getHeaderGroups().map(headerGroup => (
                                <tr key={headerGroup.id}>
                                    {headerGroup.headers.map(header => {
                                        return (
                                            <th key={header.id} colSpan={header.colSpan} scope="colgroup" className={header.column.columnDef.className}>
                                                {header.isPlaceholder ? null : (
                                                    <div>
                                                        {flexRender(
                                                            header.column.columnDef.header,
                                                            header.getContext()
                                                        )}
                                                    </div>
                                                )}
                                            </th>
                                        )
                                    })}
                                </tr>
                            ))}
                            </thead>
                            <tbody className="content">
                            {table.getRowModel().rows.map(row => {
                                return (
                                    <tr className="line" key={row.id}>
                                        {row.getVisibleCells().map(cell => {
                                            return (
                                                <td key={cell.id} className={cell.column.columnDef.className}>
                                                    {flexRender(
                                                        cell.column.columnDef.cell,
                                                        cell.getContext()
                                                    )}
                                                </td>
                                            )
                                        })}
                                    </tr>
                                )
                            })}
                            </tbody>
                        </table>
                    </div>

                    <div className="pagination">
                        <button className="first-page prev-link"
                                onClick={() => { table.setPageIndex(0); _h3Ref.current.focus(); }}
                                disabled={!table.getCanPreviousPage()}>
                            <span className="maificon maificon-arrow-left" aria-hidden="true"></span>
                            <span className="maificon maificon-arrow-left" aria-hidden="true"></span>
                            {" Première"}
                        </button>
                        <button className="prev-link"
                                onClick={() => { table.previousPage(); _h3Ref.current.focus(); }}
                                disabled={!table.getCanPreviousPage()}>
                            <span className="maificon maificon-arrow-left" aria-hidden="true"></span>
                            {" Précédent"}
                        </button>
                        <div className="page">
                            <input
                                className="pagination-page"
                                type="number"
                                min={1}
                                max={table.getPageCount()}
                                value={table.getState().pagination.pageIndex + 1}
                                onChange={e => {
                                    const page = e.target.value ? Number(e.target.value) - 1 : 0
                                    table.setPageIndex(page);
                                    _h3Ref.current.focus();
                                }}
                                title="Saisir un numéro de page - vous serez redirigé en début de tableau dès la saisie d'un numéro"
                            />
                            <p>{`/ ${table.getPageCount()}`}</p>
                        </div>
                        <button className="next-link"
                                onClick={() => { table.nextPage(); _h3Ref.current.focus(); }}
                                disabled={!table.getCanNextPage()}>
                            {"Suivant "}
                            <span className="maificon maificon-arrow-right" aria-hidden="true"></span>
                        </button>
                        <button className="last-page next-link"
                                onClick={() => { table.setPageIndex(table.getPageCount() - 1); _h3Ref.current.focus(); }}
                                disabled={!table.getCanNextPage()}>
                            {"Dernière "}
                            <span className="maificon maificon-arrow-right" aria-hidden="true"></span>
                            <span className="maificon maificon-arrow-right" aria-hidden="true"></span>
                        </button>
                    </div>

                </div>
            </div>
        </div>
    )
}